module.exports = __webpack_public_path__ + "static/media/studio-slide2.7d2a2117.png";